export enum InstallationStatus {
  Downloaded = 'DOWNLOADED',
  NotDownloaded = 'NOT_DOWNLOADED'
}
